var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKakaotalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4003_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9998 5.41675C7.91359 5.41675 3.7915 8.62341 3.7915 12.5776C3.7915 14.3705 4.64192 16.0009 6.03942 17.2576L4.81525 20.7622L8.31442 18.7363C9.69025 19.3701 11.2882 19.7384 12.9998 19.7384C18.0861 19.7384 22.2082 16.5317 22.2082 12.5776C22.2082 8.62341 18.0861 5.41675 12.9998 5.41675Z",
    fill: "url(#paint0_linear_4003_481)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_4003_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.93734 13.9047C9.22466 13.9047 9.50021 13.7906 9.70337 13.5874C9.90653 13.3842 10.0207 13.1087 10.0207 12.8214C10.0207 12.5341 9.90653 12.2585 9.70337 12.0553C9.50021 11.8522 9.22466 11.738 8.93734 11.738C8.65002 11.738 8.37447 11.8522 8.17131 12.0553C7.96814 12.2585 7.854 12.5341 7.854 12.8214C7.854 13.1087 7.96814 13.3842 8.17131 13.5874C8.37447 13.7906 8.65002 13.9047 8.93734 13.9047ZM13.1353 13.9047C13.4226 13.9047 13.6981 13.7906 13.9013 13.5874C14.1045 13.3842 14.2186 13.1087 14.2186 12.8214C14.2186 12.5341 14.1045 12.2585 13.9013 12.0553C13.6981 11.8522 13.4226 11.738 13.1353 11.738C12.8479 11.738 12.5724 11.8522 12.3692 12.0553C12.1661 12.2585 12.0519 12.5341 12.0519 12.8214C12.0519 13.1087 12.1661 13.3842 12.3692 13.5874C12.5724 13.7906 12.8479 13.9047 13.1353 13.9047ZM17.3332 13.9047C17.6205 13.9047 17.896 13.7906 18.0992 13.5874C18.3024 13.3842 18.4165 13.1087 18.4165 12.8214C18.4165 12.5341 18.3024 12.2585 18.0992 12.0553C17.896 11.8522 17.6205 11.738 17.3332 11.738C17.0459 11.738 16.7703 11.8522 16.5671 12.0553C16.364 12.2585 16.2498 12.5341 16.2498 12.8214C16.2498 13.1087 16.364 13.3842 16.5671 13.5874C16.7703 13.7906 17.0459 13.9047 17.3332 13.9047Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_4003_481",
    x: 7.854,
    y: 11.738,
    width: 11.1042,
    height: 2.96675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.955116 0 0 0 0 0.604907 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4003_481"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4003_481",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.541667,
    dy: 0.541667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.541667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4003_481"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4003_481",
    x1: 4.604,
    y1: 13.0001,
    x2: 22.2082,
    y2: 13.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#BBBBBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4003_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaotalk);
export default __webpack_public_path__ + "static/media/kakaotalk.1c5fbd5ef41cbb59cf78d2a39ff0ccff.svg";
export { ForwardRef as ReactComponent };